import * as React from 'react';
import { getLanguage } from '@citrite/translate';
import {
	CitrixUIProvider as CitrixUI,
	palette,
	useBreakpoints,
} from '@citrite/web-ui-component';
import { ThemeColors } from '@citrite/web-ui-component/dist/typings/Theme/ThemeColors';
import { useTheme } from '@emotion/react';
import { useBranding } from 'Configuration/withBranding';
import { FeatureFlag } from 'Environment/FeatureFlag';
import { isNativeMobileClient } from 'Environment/launchResource/device';
import { getHistory } from 'Router/BrowserHistory';
import { useFeatureCanary } from 'utils/useFeatureCanary';

export interface Props {
	children?: React.ReactNode;
}

export function CitrixUIProvider(props: Props) {
	const breakpoints = useBreakpoints();
	const branding = useBranding();
	const { mastheadOffset, mastheadOffsetMobile } = useTheme().mastheadOffset;

	const daasVisionThemeOverrides: Partial<ThemeColors> = {
		primaryAppBackground: palette.white,
	};

	const blueThemeOverrides: Partial<ThemeColors> = useFeatureCanary(
		FeatureFlag.AllowBlueTheme
	)
		? {
				primary: branding.styles.AccentColor,
				action: branding.styles.AccentColor,
				actionHover: branding.styles.AccentColor,
		  }
		: {};

	return (
		<CitrixUI
			configuration={{
				notificationContainerLocation:
					isNativeMobileClient() && breakpoints.screenSize.onMobile
						? { zIndex: 11, bottom: 50 }
						: { zIndex: 11 },
				theme: {
					paletteName: branding.paletteName,
					themeColorOverrides: {
						activeTab: branding.styles.AccentColor,
						...daasVisionThemeOverrides,
						...blueThemeOverrides,
					},
				},
				scrollOffset: breakpoints.screenSize.onMobile
					? mastheadOffsetMobile
					: mastheadOffset,
				history: getHistory(),
				language: getLanguage(),
			}}
		>
			{props.children}
		</CitrixUI>
	);
}
